// tree-with-table.component.ts

import { Component, OnInit, Input,QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Observable, forkJoin, map, throwError, catchError, of } from 'rxjs';
import { WorkflowsService } from '../../system/workflows/service/workflows.service';
import { DatasetResults } from '../model/workbench-results-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
//import { NodeHistory } from '../queued/queued.component';


const sortingDataAccessor = (item: DatasetResults, property: string) => {
  switch (property) {
    case 'CREATED_DATE':
            if (item?.CREATED_DATE) return item.CREATED_DATE?.toString();
            else return '';  
    case 'UPDATED_DATE':
            if (item?.UPDATED_DATE) return item.UPDATED_DATE?.toString();
            else return '';  
    case 'REGION':
            if (item?.CODE) return item.CODE?.toString();
            else return '';
    case 'RECRUITER':
            if (item?.RECRUITER_NAME) return item.RECRUITER_NAME.toString().toLocaleLowerCase();
            else return '';
    default:
          if (item?.ID) return item.ID;
          else return '';
  }
};

/*export interface TableResult {
  ID: number;
  CREATED_DATE: string;
  UPDATED_DATE: string;
  NODE_HISTORIES: NodeHistory[];
  NODE_COES: { CO: { CURRENT_CITY: string } }[];
  lastestUpdatedDate?: string; // optional property
  RECRUITER_NAME: string;
  ORGANIZATION: string
  CURRENT_CITY: string;
  SCHOOL_NAME: string;
  CODE: number;
  COE_NUMBER: string
}*/

@Component({
  selector: 'app-tree-with-table',
  templateUrl: './tree-with-table.component.html',
  styleUrls: ['./tree-with-table.component.scss']
})

export class TreeWithTableComponent implements OnInit {
 // @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
  //@ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
  @ViewChild(MatPaginator) searchPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  loadingWorkflows = false;
  workflows: any[] = [];
  states: any[] = [];
  show: { [key: string]: boolean } = {};
  getPropertyPipe = new GetPropertyPipe();
  nodeLength: number;
  //tableResult: TableResult[] = [];
  //dataSource: MatTableDataSource <TableResult[]> ;
  //dataSource = new MatTableDataSource<TableResult>();
  //dataSource = new MatTableDataSource<DatasetResults>();
  dataSource: any[] = [];
  tableDataSources: MatTableDataSource<any>[] = [];
  dataSource_WithPagination: MatTableDataSource<any> = new MatTableDataSource<any>();
  // Table results
  //tableDataSources: MatTableDataSource<DatasetResults>[] = [];
  //Table display
  /*olumns = {
    CREATED_DATE: {INDEX:1, ENABLED: true, SORT: 'CREATED_DATE', DATA: 'CREATED_DATE', DISABLED: false}
    //Recruiter
    NODE_COES[0].CO.RECRUITER_NAME
    //Updated
    lastestUpdatedDate
    //First Name
    NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.FIRST_NAME
    //Last Name
    NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.LAST_NAME
    //Email
    NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.ID
    //Region
    NODE_REGIONS[0].REGION.CODE
    //Provisional School Name
    NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.SCHOOL_NAME
    //Current City
    NODE_COES[0].CO.CURRENT_CITY
    //COE #
    NODE_COES[0].CO.COE_NUMBER
    //Toggle to show provisional schools only
    Organization
    //Status
    WORKFLOW_STATE_TYPES.DESCRIPTION
  };
  */

  displayedColumns: string[] = ['ID','CREATED_DATE', 'UPDATED_DATE','REGION', 'RECRUITER_NAME','ORGANIZATION','CURRENT_CITY','COE_NUMBER'];
  constructor(private workflowsService: WorkflowsService) {}
  
  ngOnInit(): void {
    this.init();
  }

  init() {
    this.getWorkflows();
  }

  getWorkflows(): void {
    this.loadingWorkflows = true;

    this.workflowsService.getMyWorkflows().pipe(
      catchError(err => {
        this.loadingWorkflows = false;
        // Handle the error here if needed
        return of(null); // Return a fallback value
      })
    ).subscribe(res => {
      this.loadingWorkflows = false;

      if (res?.workflows) {
        this.workflows = res.workflows;
        //console.log("this.workflows",  this.workflows)
        if (this.workflows.length === 1) {
          this.show[this.workflows[0].NAME] = true;
        }
        
        this.workflows.forEach((workflow, index) => {
          this.getWorkflowStates(workflow.ID, index);
          //this.getWorkflowStates(4, 1);
        });
      } else if (res?.msg?.SUCCESS === false) {
        // Handle failure case
      }
    });
  }

  getWorkflowStates(workflowID: number, workflowIndex: number) {
    let loading: any = {}
    loading[workflowID] = true;

    this.workflowsService.getInboxStates(workflowID).subscribe({
      next: (res) => {
        if (res?.states) {
          this.states =   JSON.parse(res.states)
          //console.log("getInboxStates Raw Data()",  JSON.parse(res.states));
          this.workflows[workflowIndex].states = this.states;
          //console.log("getInboxStates()", this.workflows[workflowIndex].states);
        }
        else if (res.msg) {
          //this.msg = res.msg;
          this.workflows[workflowIndex].states = [];
        } else {
          //this.msg = { SUCCESS: false, MSG: 'Error retrieving InboxStates.' };
        }
        loading[workflowID] = false;
      },
      error: (err) => {
        //this.msg = { SUCCESS: false, MSG: 'Error retrieving InboxStates.' };
        loading[workflowID] = false;
      },
      complete: () => {
        // Display results
        if (this.states.length > 0) {
          //console.log("calling updatedata",workflowID);
          //console.log("workflowIndex",workflowIndex);
          //console.log("this.states.length",this.states.length);
          this.updateDataSource2(this.states);
          //console.log("this.states",this.states);
      }
      }
    });
  }

  updateDataSource2(state: any[]): void {
    console.log("states.length", state.length)

    //if (state.length == 1)
    //{
     for (let index = 0; index < this.states.length; index++) {
      
        const state = this.states[index].NODES;
     
        // Create a new MatTableDataSource for each state's NODES
        //const dataSource1 = new MatTableDataSource(state.NODES);
        //console.log("dataSource----", state.NODES);
        this.dataSource = state;
        console.log("if dataSource----", this.dataSource)
        // Optional: Log length of nodes for debugging
        //this.nodeLength = state.NODES.length;
        //console.log("nodeLength:", this.nodeLength);
    
        //this.tableDataSources[index] = dataSource;
        // Store the dataSource in tableDataSources array
        //this.tableDataSources[index] = dataSource;
        //this.tableDataSources[index] = dataSource;
      }
    /*}
    else
    {
      console.log("else")
      //console.log("NODEs",state[i].NODES)
      for (let index = 0; index < this.states.length; index++) {
        const node = this.states[index].NODES;
        this.dataSource = node;
        console.log("if dataSource----", this.dataSource)
        //this. updateDataSource3(node)
      }

    }*/
    
    
}

cleanState(states: any[]): any[] {

    states.forEach(state => {
      state.NODES.forEach((node: { 
        CREATED_DATE: string; 
        NODE_HISTORIES: string | any[]; 
        lastestUpdatedDate: any; 
        NODE_COES: string | any[]; 
        NODE_REGIONS: string | any[]; 
        NODE_PROVISIONAL_SCHOOLS: string | any[]; 
        NODE_ACCOUNT_REQUESTS: string | any[];}) => {
          
        // Format the CREATED_DATE using a hypothetical date formatting function
        node.CREATED_DATE = this.simpleDateTime(node.CREATED_DATE);
        
        if (node.NODE_HISTORIES && node.NODE_HISTORIES.length > 0) {
          const latestHistory = node.NODE_HISTORIES[node.NODE_HISTORIES.length - 1];
          latestHistory.CREATED_DATE = this.simpleDateTime(latestHistory.CREATED_DATE);
          node.lastestUpdatedDate = latestHistory.CREATED_DATE;
        }
  
        if (node.NODE_COES && node.NODE_COES.length > 0 && node.NODE_COES[0].CO.CURRENT_CITY) {
          node.NODE_COES[0].CO.CURRENT_CITY = this.titleText(node.NODE_COES[0].CO.CURRENT_CITY);
        }
        if (node.NODE_COES && node.NODE_COES.length > 0 && node.NODE_COES[0].CO.RECRUITER_NAME) {
          node.NODE_COES[0].CO.RECRUITER_NAME = this.titleText(node.NODE_COES[0].CO.RECRUITER_NAME);
        }
        if (node.NODE_REGIONS && node.NODE_REGIONS.length > 0 && node.NODE_REGIONS[0].REGION.CODE) {
          node.NODE_REGIONS[0].REGION.CODE =  node.NODE_REGIONS[0].REGION.CODE;
        }
        if (node.NODE_PROVISIONAL_SCHOOLS && node.NODE_PROVISIONAL_SCHOOLS.length > 0 && node.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.SCHOOL_NAME) {
          node.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.SCHOOL_NAME =  node.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.SCHOOL_NAME;
        }
        if (node.NODE_PROVISIONAL_SCHOOLS && node.NODE_PROVISIONAL_SCHOOLS.length > 0 && node.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.CO.COE_NUMBER) {
          node.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.CO.COE_NUMBER =  node.NODE_PROVISIONAL_SCHOOLS[0].PROVISIONAL_SCHOOLS.CO.COE_NUMBER;
        }
        if (node.NODE_COES && node.NODE_COES.length > 0 && node.NODE_COES[0].CO.COE_NUMBER) {
          node.NODE_COES[0].CO.COE_NUMBER = this.titleText(node.NODE_COES[0].CO.COE_NUMBER);
        }
        if (node.NODE_REGIONS && node.NODE_REGIONS.length > 0 && node.NODE_REGIONS[0].REGION.ORGANIZATION.NAME) {
          node.NODE_REGIONS[0].REGION.ORGANIZATION.NAME =  node.NODE_REGIONS[0].REGION.ORGANIZATION.NAME;
        }
        if (node.NODE_ACCOUNT_REQUESTS && node.NODE_ACCOUNT_REQUESTS.length > 0 && node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.FIRST_NAME)
        {
            node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.FIRST_NAME =  node.NODE_ACCOUNT_REQUESTS[0].ACCOUNT_REQUESTS.FIRST_NAME;
        }

        
      });
    });
    //console.log("cleanState----",states)
    return states;
}
  
simpleDateTime(date: string): string {
    // Implement your date formatting logic here
    return date; // Replace with actual formatted date
}

titleText(text: string): string {
    // Implement your title text formatting logic here
    return text; // Replace with actual formatted text
}

toggleShow(obj: any) {
    obj.SHOW = !obj.SHOW;
}

  /*generateDisplayColumns(schoolYear: string, prefixColumns?: string[]) {
    let displayedColumns: string[] = prefixColumns ? prefixColumns : [];
    let columns: any = this.columns;
    //displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

    const properties = Object.keys(columns);
    properties.forEach((property) => {
        if (columns[property].ENABLED) {
            displayedColumns.push(columns[property].SORT);
        }
    });

    return displayedColumns;
}*/

updateDataSource(){
  //console.log("calling updateDataSource")
  //let mydata: any[];
  //mydata  = this.states;
  //console.log("dataSource.data",mydata) ; 
  //this.tableDataSources.push(mydata);
//************ */
this.states.forEach((state, index) => {
  //console.log("length:", state.length)
  state.NODES.forEach((node: { CREATED_DATE: string; NODE_HISTORIES: string | any[]; lastestUpdatedDate: any; NODE_COES: string | any[]; NODE_REGIONS: string | any[];}) => {
    // Format the CREATED_DATE using a hypothetical date formatting function
   
    node.CREATED_DATE = this.simpleDateTime(node.CREATED_DATE);
    /*if (node.NODE_HISTORIES && node.NODE_HISTORIES.length > 0) {
      const latestHistory = node.NODE_HISTORIES[node.NODE_HISTORIES.length - 1];
      latestHistory.CREATED_DATE = this.simpleDateTime(latestHistory.CREATED_DATE);
      node.lastestUpdatedDate = latestHistory.CREATED_DATE;
    }*/

    /*if (node.NODE_COES && node.NODE_COES.length > 0 && node.NODE_COES[0].CO.CURRENT_CITY) {
      node.NODE_COES[0].CO.CURRENT_CITY = this.titleText(node.NODE_COES[0].CO.CURRENT_CITY);
    }
    if (node.NODE_COES && node.NODE_COES.length > 0 && node.NODE_COES[0].CO.RECRUITER_NAME) {
      node.NODE_COES[0].CO.RECRUITER_NAME = this.titleText(node.NODE_COES[0].CO.RECRUITER_NAME);
    }
    if (node.NODE_REGIONS && node.NODE_REGIONS.length > 0 && node.NODE_REGIONS[0].REGION.CODE) {
      node.NODE_REGIONS[0].REGION.CODE =  node.NODE_REGIONS[0].REGION.CODE;
    }
    if (node.NODE_COES && node.NODE_COES.length > 0 && node.NODE_COES[0].CO.COE_NUMBER) {
      node.NODE_COES[0].CO.COE_NUMBER = this.titleText(node.NODE_COES[0].CO.COE_NUMBER);
    }*/
    });
})

}


updateDataSource3(node:any[])
{
  if (node)
  {
      console.log("state",node.length)
      this.dataSource = node;
      console.log("NODEs", this.dataSource)
  }
  //this.dataSource = new MatTableDataSource(node);
  //for(let i=0; i<node.length; i++)
  //{
  //  console.log("NODEs",state[i].NODES)
              //this.dataSource = new MatTableDataSource(state.NODES);
            
  //}
}

}
